import React from 'react'
import aboutcontent from '../components/images/about-content.jpg'

function WhoWeAre() {
  return (
    <>
    <div className='about-intro'>
            <div className='content'>
            <div className='contentimg'>
                <img src={"https://content.acetians.in/uploads/Gemini_Generated_Image_y5x1p2y5x1p2y5x1.png"} alt='' />
            </div>
            <div> 
                <h1>WHO WE ARE</h1>

              <p>
                SGMR Pharmaceuticals Pvt Ltd. is a renowned Loan License
                manufacturer of API’s and Intermediates. We are headquartered in
                Hyderabad, Telangana, India. And also we have our marketing
                branches in Dubai and Manchester(UK). We specialize in the
                product manufacturing and export of Bulk drugs Products and
                Intermediates. Our customers and buyers include reputed
                pharmaceutical companies of the US, Europe, Middle-East, Africa,
                Latin America, and the CIS region, Asian Countries.
              </p>
              <p>
                Starting from a single product line, SGMR Pharmaceuticals Pvt
                Ltd has emerged as a diversified multi-product company, with
                interests in the production of API Products and API
                Intermediates. We bring together more than 10 years of
                experience in the manufacturing of API Products and
                Intermediates.
              </p>
              <p>
                Our business, the methodology aims to realize to completion
                futuristic synergy of backward integration. We ensure that at no
                point of time our production commitments to our clients in
                supplying API products and Extended Products will be met 100%.
              </p>{" "}
            </div>
            </div>
    </div>
    </>
  )
}

export default WhoWeAre